import * as Actions from './actionTypes';
import { findIndex, find } from 'lodash';

const initialData = {
  loading: false,
  errors: false,
  surveyCanBeTaken: connectspace_config.event_or_session_surveys_can_be_taken,
  loadingSurveyCanBeTaken: false,
  surveyCanBeTakenError: false,
  marqueeItems: connectspace_config.marqueeItems,
  showSurveyModal: false,
  activeSurveyIndex: false,
  surveyModalTitle: "All Surveys",
  surveyModalButtonType: "dismiss",
  loadingSurveys: false,
  surveyErrors: false,
  surveys: [],
  surveyNextPage: false,
  liveStreamNextPage: connectspace_config.marqueeItems.length > 25 ? 1 : false
};

const marqueeData = (state = initialData, action) => {
  switch (action.type) {
    case Actions.FETCH_LIVE_STREAMS_BEGIN:
      return {
        ...state,
        loading: true,
        errors: false
      }
    case Actions.FETCH_LIVE_STREAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        liveStreamNextPage: action.payload.pagination.next_page,
        marqueeItems: [...state.marqueeItems, ...action.payload.live_streams]
      }
    case Actions.FETCH_LIVE_STREAMS_ERROR:
      return {
        ...state,
        loading: false,
        errors: true
      }
    case Actions.FETCH_SURVEYS_CAN_BE_TAKEN_BEGIN:
      return {
        ...state,
        loadingSurveyCanBeTaken: true
      }
    case Actions.FETCH_SURVEYS_CAN_BE_TAKEN_SUCCESS:
      return {
        ...state,
        loadingSurveyCanBeTaken: false,
        surveyCanBeTaken: action.payload.can_be_taken
      }
    case Actions.FETCH_SURVEYS_CAN_BE_TAKEN_ERROR:
      return {
        ...state,
        loadingSurveyCanBeTaken: false,
        surveyCanBeTakenError: true
      }
    case Actions.GO_BACK_TO_SURVEYS:
      return {
        ...state,
        activeSurveyIndex: false,
        surveyModalTitle: "All Surveys",
        surveyModalButtonType: "dismiss"
      }
    case Actions.CLOSE_SURVEY_MODAL:
      return {
        ...state,
        showSurveyModal: false
      }
    case Actions.SHOW_SURVEY_MODAL:
      return {
        ...state,
        showSurveyModal: true
      }
    case Actions.FETCH_SURVEYS_BEGIN:
      return {
        ...state,
        loadingSurveys: true,
        surveyErrors: false
      }
    case Actions.FETCH_SURVEYS_SUCCESS:
      return {
        ...state,
        loadingSurveys: false,
        surveyNextPage: action.payload.pagination.next_page,
        surveys: [...state.surveys, ...action.payload.surveys]
      }
    case Actions.FETCH_SURVEYS_ERROR:
      return {
        ...state,
        loadingSurveys: false,
        surveyErrors: true
      }
    case Actions.SHOW_SURVEY_FROM_ID:
      let surveyIndex = findIndex(state.surveys, { 'id': action.surveyId });
      let activeSurvey = find(state.surveys, { 'id': action.surveyId });
      return {
        ...state,
        activeSurveyIndex: surveyIndex,
        showSurveyModal: true,
        surveyModalTitle: activeSurvey.surveyable_type + " Survey",
        surveyModalButtonType: action.buttonType
      }
    default:
      return state
  }
}

export default marqueeData;